<template>
  <div>
    <view-table
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        :table-action="false"
        :table-select="false"
        module="basic"
        url="apiMonitor/logs"
        @reset="resetHandle">
      <template slot="adSearch">
        <div class="vm-search">
          <el-form :inline="true" :model="filter" label-width="80px" @keyup.enter.native="loadData(1)">
            <el-form-item label="请求时间">
              <el-date-picker
                  v-model="requestTimeRange"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd HH:mm"
                  format="yyyy-MM-dd HH:mm"
                  @change="onRequestTimeChange"/>
            </el-form-item>
            <el-form-item label="来源IP">
              <el-input v-model.trim="filter.sourceIp" placeholder="请输入" clearable/>
            </el-form-item>
            <el-form-item label="用户名">
              <el-input v-model.trim="filter.userName" placeholder="请输入" clearable/>
            </el-form-item>
            <el-form-item label="请求路径">
              <el-input v-model.trim="filter.requestPath" placeholder="请输入" clearable/>
            </el-form-item>
            <el-form-item label="Token状态">
              <el-select v-model="filter.tokenStatus" clearable placeholder="请选择">
                <el-option label="无Token" :value="0"/>
                <el-option label="有效" :value="1"/>
                <el-option label="无效/过期" :value="2"/>
              </el-select>
            </el-form-item>
            <el-form-item label="慢查询">
              <el-select v-model="filter.slowQueryOnly" clearable placeholder="请选择">
                <el-option label="是" :value="true"/>
                <el-option label="否" :value="false"/>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </template>
    </view-table>
  </div>
</template>

<script>
  import ViewTable from "@/components/ViewTable";

  export default {
    name: "AccessLogList",
    components: { ViewTable },
    data() {
      return {
        limits: {
          addAuth: false,
          editAuth: false,
          delAuth: false,
        },
        filter: {
          sourceIp: "",
          userName: "",
          requestPath: "",
          tokenStatus: "",
          slowQueryOnly: "",
          requestTimeBegin: "",
          requestTimeEnd: "",
        },
        requestTimeRange: [],
        columnsProperty: [
          {
            key: "requestTime",
            width: 160,
            align: "center",
          },
          {
            key: "sourceIP",
            width: 220,
            render: (h, params) => {
              return h("span", { style: { display: "inline-flex", alignItems: "center" } }, [
                h(
                  "el-link",
                  {
                    props: { type: "danger", underline: false },
                    style: { marginRight: "8px" },
                    on: {
                      click: (ev) => {
                        if (ev && ev.stopPropagation) ev.stopPropagation();
                        this.optionIp(params.row, 1);
                      },
                    },
                  },
                  "封禁",
                ),
                h(
                  "el-link",
                  {
                    props: { type: "success", underline: false },
                    style: { marginRight: "8px" },
                    on: {
                      click: (ev) => {
                        if (ev && ev.stopPropagation) ev.stopPropagation();
                        this.optionIp(params.row, 0);
                      },
                    },
                  },
                  "解封",
                ),
                h("span", params.row.sourceIP || ""),
              ]);
            },
          },
          {
            key: "requestPath",
            minWidth: 200,
            tooltip: true,
          },
          {
            key: "userName",
            width: 100,
            align: "center",
          },
          {
            key: "tokenStatus",
            width: 110,
            align: "center",
            render: (h, params) => {
              const val = params.row.tokenStatus;
              let text = "-";
              let color = "";
              if (val === 0) { text = "无Token"; color = "#909399"; }
              else if (val === 1) { text = "有效"; color = "#67C23A"; }
              else if (val === 2) { text = "无效/过期"; color = "#F56C6C"; }
              return h("span", { style: { color } }, text);
            },
          },
          {
            key: "statusCode",
            width: 110,
            align: "center",
          },
          {
            key: "timeCost",
            title: "耗时(ms)",
            width: 110,
            align: "center",
            sortable: true,
          },
          {
            key: "userAgent",
            minWidth: 180,
            tooltip: true,
          },
          {
            key: "requestParams",
            minWidth: 200,
            tooltip: true,
          },
          {
            key: "errorMessage",
            minWidth: 150,
            tooltip: true,
          },
          {
            key: "module",
            width: 120,
            align: "center",
          },
        ],
      };
    },

    methods: {
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      onRequestTimeChange(val) {
        if (val && val.length === 2) {
          this.filter.requestTimeBegin = val[0];
          this.filter.requestTimeEnd = val[1];
        } else {
          this.filter.requestTimeBegin = "";
          this.filter.requestTimeEnd = "";
        }
      },

      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
        this.requestTimeRange = [];
      },

      optionIp(row, status) {
        if (status === 1) {
          this.$confirm("确定封禁当前IP吗?", "提示", { type: "warning" }).then(() => {
            this.$http.post("basic", "apiMonitor/blacklist/block", "", {
              blockIp: row.sourceIP,
              reason: "web端手动封禁",
            }).then(() => {
              this.$message.success("封禁成功");
            });
          }).catch(() => {});
        } else {
          this.$confirm("确定解封当前IP吗?", "提示", { type: "warning" }).then(() => {
            this.$http.post("basic", "apiMonitor/blacklist/unblockByIp", "", {
              blockIp: row.sourceIP,
            }).then(() => {
              this.$message.success("解封成功");
            });
          }).catch(() => {});
        }
      },
    },
  };
</script>
